/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as DatePickerDefault } from './date-picker-default.story';
export { default as DatePickerStartsOnMonday } from './date-picker-starts-on-monday.story';
export { default as DatePickerMinMaxDate } from './date-picker-min-max-date.story';
export { default as DatePickerOpensToDate } from './date-picker-opens-to-date.story';
export { default as DatePickerTextInputProps } from './date-picker-text-input-props.story';
export { default as DatePickerWithTimePicker } from './date-picker-with-time-picker.story';
export { default as DatePickerWithTimeZone } from './date-picker-with-timezone.story';
export { default as DatePickerWithTimeZoneBothMode } from './date-picker-with-timezone-both-mode.story';
export { default as DatePickerDisabled } from './date-picker-disabled.story';
export { default as DatePickerInDialog } from './date-picker-in-dialog.story';
export { default as DatePickerFull } from './date-picker-full.story';
export { default as DatePickerPortaled } from './date-picker-portaled.story';
export { default as DatePickerRange } from './date-picker-range.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import DatePickerDefaultSourceRaw from './date-picker-default.story.tsx?raw';
import DatePickerDisabledSourceRaw from './date-picker-disabled.story.tsx?raw';
import DatePickerFullSourceRaw from './date-picker-full.story.tsx?raw';
import DatePickerInDialogSourceRaw from './date-picker-in-dialog.story.tsx?raw';
import DatePickerMinMaxDateSourceRaw from './date-picker-min-max-date.story.tsx?raw';
import DatePickerOpensToDateSourceRaw from './date-picker-opens-to-date.story.tsx?raw';
import DatePickerPortaledSourceRaw from './date-picker-portaled.story.tsx?raw';
import DatePickerRangeSourceRaw from './date-picker-range.story.tsx?raw';
import DatePickerStartsOnMondaySourceRaw from './date-picker-starts-on-monday.story.tsx?raw';
import DatePickerTextInputPropsSourceRaw from './date-picker-text-input-props.story.tsx?raw';
import DatePickerWithTimePickerSourceRaw from './date-picker-with-time-picker.story.tsx?raw';
import DatePickerWithTimeZoneSourceRaw from './date-picker-with-timezone.story.tsx?raw';
import DatePickerWithTimeZoneBothModeSourceRaw from './date-picker-with-timezone-both-mode.story.tsx?raw';

export const DatePickerDefaultSource = removeLicenseHeader(
  DatePickerDefaultSourceRaw,
);
export const DatePickerStartsOnMondaySource = removeLicenseHeader(
  DatePickerStartsOnMondaySourceRaw,
);
export const DatePickerMinMaxDateSource = removeLicenseHeader(
  DatePickerMinMaxDateSourceRaw,
);
export const DatePickerOpensToDateSource = removeLicenseHeader(
  DatePickerOpensToDateSourceRaw,
);
export const DatePickerTextInputPropsSource = removeLicenseHeader(
  DatePickerTextInputPropsSourceRaw,
);
export const DatePickerWithTimePickerSource = removeLicenseHeader(
  DatePickerWithTimePickerSourceRaw,
);
export const DatePickerWithTimeZoneSource = removeLicenseHeader(
  DatePickerWithTimeZoneSourceRaw,
);
export const DatePickerWithTimeZoneBothModeSource = removeLicenseHeader(
  DatePickerWithTimeZoneBothModeSourceRaw,
);
export const DatePickerDisabledSource = removeLicenseHeader(
  DatePickerDisabledSourceRaw,
);
export const DatePickerInDialogSource = removeLicenseHeader(
  DatePickerInDialogSourceRaw,
);
export const DatePickerFullSource = removeLicenseHeader(
  DatePickerFullSourceRaw,
);
export const DatePickerPortaledSource = removeLicenseHeader(
  DatePickerPortaledSourceRaw,
);
export const DatePickerRangeSource = removeLicenseHeader(
  DatePickerRangeSourceRaw,
);
